import { Injectable, NgZone, inject } from '@angular/core';
import { PasswordService } from '@app/core/services/password.service';
import { PopupService } from './popup.service';

@Injectable({
  providedIn: 'root',
})
export class InterfaceService {
  private zone = inject(NgZone);
  private passwordService = inject(PasswordService);
  private popupService = inject(PopupService);

  public install(): void {
    window['getService'] = (name) => {
      return this.zone.run(() => {
        switch (name) {
          case 'passwordService':
            return this.passwordService;
          case 'popupService':
            return this.popupService;
          default:
            throw new Error('unknown service ' + name);
        }
      });
    };
  }
}
